import React from 'react';
import { Textarea as TUITextarea, TextareaProps } from '@apia/theme';
import { useField } from '../hooks/useField';
import { useValidationClass } from '../hooks/useValidationClass';
import { FieldWrapper } from './FieldWrapper';
import { TDefaultFieldType } from './types';

type TTextarea = TextareaProps & TDefaultFieldType;

export const Textarea = React.forwardRef<HTMLTextAreaElement, TTextarea>(
  (
    {
      avoidSemicolon,
      className,
      formName,
      label,
      onChange: outerOnChange,
      /**
       * useField
       */
      avoidRegisterIfExists,
      initialValue,
      name,
      removeOnUnmount,
      submitValueParser,
      validationClass,
      validationFunction,
      validationRules,
      value,
      ...props
    },
    ref,
  ) => {
    const { actualValidationFunction, actualValidationRules } =
      useValidationClass({
        formName,
        name,
        validationClass,
        validationFunction,
        validationRules,
      });
    const { updateValidations, onChange, isTouched, ...inputProps } =
      useField<string>({
        avoidRegisterIfExists,
        formName,
        initialValue: initialValue ?? (value as string),
        name,
        removeOnUnmount,
        submitValueParser,
        validationRules: actualValidationRules,
        validationFunction: actualValidationFunction,
      });
    const handleOnChange = React.useCallback(
      (ev: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange(ev);
        if (outerOnChange) {
          outerOnChange(ev);
        }
      },
      [onChange, outerOnChange],
    );
    return (
      <FieldWrapper
        name={name}
        label={label}
        className={`textarea ${className ?? ''}`}
        avoidSemicolon={avoidSemicolon}
      >
        <TUITextarea
          {...props}
          {...inputProps}
          aria-label={props['aria-label'] ?? label}
          ref={ref}
          value={inputProps.value ?? ''}
          onChange={handleOnChange}
        />
      </FieldWrapper>
    );
  },
);

Textarea.displayName = 'Textarea';
